
    import {
        defineComponent, PropType,
    } from 'vue';

    import { PartialPaymentTourProduct } from '@ve/components/partialPayment/common/types/PartialPaymentTourProduct';
    import { PartialPaymentProductType } from '@ve/components/partialPayment/common/types/PartialPaymentProductType';

    import usePartialPaymentPopupRef from '@ve/components/partialPayment/common/use/usePartialPaymentPopupRef';
    import usePartialPaymentBannerForHotelPage from '../common/use/usePartialPaymentBannerForHotelPage';

    export default defineComponent({
        name: 'PartialPaymentBannerForHotelPage',
        props: {
            countryName: {
                type: String,
                default: '',
            },
            products: {
                type: Array as PropType<PartialPaymentTourProduct[]>,
                default: () => ([]),
            },
            productType: {
                type: String as PropType<PartialPaymentProductType>,
                default: 'tourOffer',
            },
            hotelPageProduct: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, ctx) {
            const {
                titleText,
                subTitleText,
                isVisibleBanner,
            } = usePartialPaymentBannerForHotelPage(props);

            const {
                openPopup,
                partialPaymentPopupRef,
            } = usePartialPaymentPopupRef(props, ctx);

            return {
                titleText,
                subTitleText,
                isVisibleBanner,
                openPopup,
                partialPaymentPopupRef,
            };
        },
    });
